/**
 * Created by Victor Rojo on 20/10/17.
 */
import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
 */
@Pipe({name: 'CloudUserRole'})
export class CloudUserRolePipe implements PipeTransform {
  transform(value: boolean): string {
    return value ? "Admin" : "User";
  }
}
